export const viewportSettings = {
  wheelZoomFactor: 0.05,
  zoomButtonMultiplier: 1.2,
  minZoom: 0.2,
  maxZoom: 10,
  maxBoundaries: {
    x: -5000,
    y: -5000,
    width: 10000,
    height: 10000,
  },
};

export const dragElementClassName = 'dash-drag-element';
export const helperElementClass = 'canvas-helper';
